// extracted by mini-css-extract-plugin
module.exports = {"container":"container-1IXOm","inner":"inner-1KH7E","giant":"giant-o4gHf","title":"title-3qeOC"};